/**
 * Tells the other tabs of this browser that the session ended. Every tab shares the
 * one session cookie, so a sign-out in one tab ends it for all of them, but each tab
 * keeps its own access token and cached data in memory until it hears about it.
 */
const CHANNEL = 'inovio.auth'

function channel(): BroadcastChannel | null {
  return typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel(CHANNEL)
}

export function announceSignOut(): void {
  const c = channel()
  c?.postMessage('signed-out')
  c?.close()
}

/** Runs `onSignOut` when another tab signs out. */
export function onSignOutElsewhere(onSignOut: () => void): void {
  const c = channel()
  if (c) {
    c.onmessage = (event: MessageEvent) => {
      if (event.data === 'signed-out') onSignOut()
    }
  }
}
